import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { FragmentRoot } from 'client/components/FragmentRoot'
import { FragmentRootProps } from 'client/components/FragmentRoot/interface'
import { instrumenter } from 'client/utils/instrumentation'
import { configureNewRelicLocalLogging } from 'client/utils/newrelic'
import { configureLogger } from 'shared/logger'
import { initScrollRestoration } from '~/client/utils/initScrollRestoration'

export const mount: MountWithRootOptions<FragmentRootProps> = async (rootElement, renderProps, rootOptions) => {
  const updatedRootOptions = configureNewRelicLocalLogging(rootOptions)
  const { newrelicApplicationId, newrelicLicenseKey } = updatedRootOptions.loggerOptions || {}

  initScrollRestoration()
  configureLogger(updatedRootOptions.loggerOptions)

  if (newrelicApplicationId && newrelicLicenseKey) {
    instrumenter.initNewRelicAgent(newrelicApplicationId, newrelicLicenseKey)
  }

  return clientMount(<FragmentRoot {...renderProps} />, rootElement, updatedRootOptions)
}
